var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgZa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M114.024 256.001L0 141.926v228.17z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M161.192 256L0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z",
  fill: "#6da544"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
})));

export default SvgZa;